import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m1.677 3.829 1.696-2.045c.171-.198.368-.284.577-.284h10.1c.209 0 .406.086.577.284L16.05 3.5H3.3a.75.75 0 1 0 0 1.5h13.2v3.1a.75.75 0 0 0 1.5 0V4.25a2.354 2.354 0 0 0-.514-1.369l-.009-.01-1.7-2.05-.008-.01C15.341.313 14.74 0 14.05 0H3.95c-.69 0-1.291.312-1.72.812l-.007.01-1.68 2.026C.13 3.277 0 3.83 0 4.3V9a.75.75 0 0 0 1.5 0V4.3c0-.22.063-.353.13-.42zM17.25 11.7a.75.75 0 0 1 .75.75v2.8A2.756 2.756 0 0 1 15.25 18H2.75A2.756 2.756 0 0 1 0 15.25V13.5a.75.75 0 0 1 1.5 0v1.75c0 .686.564 1.25 1.25 1.25h12.5c.686 0 1.25-.564 1.25-1.25v-2.8a.75.75 0 0 1 .75-.75"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.75 7a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }